import { useEffect } from 'react';
import AdvertSteps from './components/steps';
import { useMobileTab } from 'hooks/use-mobile-tab';
import AdvertInfoSection from './components/info';
import { useTranslation } from 'react-i18next';
import AdvertOtpModal from 'layout/advert-otp-modal';
import { selectUser } from 'store/features/userSlice';
import { useSelector } from 'react-redux';
import { UserType } from 'types';
import { toast } from 'sonner';
import { useNavigate, useParams } from 'react-router-dom';
import { paths } from 'lib/constants/paths';
import AdvertPaymentModal from 'layout/advert-payment-modal';

type Props = {
    type: 'create' | 'update';
};

const AdvertForm = ({ type }: Props) => {
    const { t } = useTranslation();
    const { user } = useSelector(selectUser);
    const { onTabChange } = useMobileTab();
    const navigate = useNavigate();
    const { id } = useParams();

    function checkUserAccess() {
        if (user?.userType !== UserType.AGENCY) return;
        if (!user.selectedPlanId && !id) {
            toast.warning(t('advert.select-plan-for-create-advert'));
            navigate(paths.cabinet.plan);
        }
    }
    useEffect(() => {
        onTabChange('createAdvert');
        checkUserAccess();
    }, []);

    return (
        <>
            <div className="absolute top-0 left-0 w-full h-[900px] bg-home"></div>
            <div className="w-full px-5 md:px-0 md:w-[925px] lg:w-[1400px] md:mx-auto z-[1] relative">
                <h1 className="text-txt text-xl md:text-4xl md:text-left text-center mb-5 md:mb-10 font-bold">
                    {t('advert.create-title')}
                </h1>
                <div className="grid gap-2 md:grid-cols-[680px,1fr] lg:grid-cols-[1060px,1fr] h-fit mt-4 md:mt-8">
                    <AdvertSteps type={type} />
                    <AdvertInfoSection />
                </div>
            </div>
            <AdvertOtpModal />
            <AdvertPaymentModal />
        </>
    );
};

export default AdvertForm;
